import {
  AsicsSpiralLogoBlue,
  mq,
  Stack,
  styled,
  useLanguageDirection,
} from '@asicsdigital/oneasics-blocks';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { StyledSubtitle } from '../form/shared';

const TitleText = styled.h3(({ theme }) => ({
  color: theme.colors.textPrimary,
  fontSize: theme.fontSizes.large,
  fontWeight: theme.fontWeights.semiBold,
  marginTop: 0,
  padding: 0,
  textAlign: 'center',
  width: '100%',
}));

const FlexSection = styled.section(({ showHeader }) =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    ...(showHeader && { paddingTop: '24px' }),
  }),
);

const Email = styled.span({
  fontWeight: 'bold',
});

const StyledLogo = styled.img({
  height: '40px',
  width: '40px',
  marginLeft: 'auto',
  marginRight: 'auto',
});

const StyledHeader = styled.header({
  marginBottom: '24px',
});

const Container = styled.div(
  mq({
    // On non-mobile devices, '20px' pushes up the content a little bit, looking more vertically centered to the eye.
    marginBottom: ['144px', '20px', '20px', '20px'],
  }),
);

/**
 * A page structure with an optional logo, title, and subtitle.
 */
const PageWrapper = ({ children = null, showHeader = true, subtitleText = '', titleText = '' }) => {
  const {
    user: { newEmail },
  } = useSelector((state) => state);

  const copyReplacement = ({ attribs }) => {
    if (!attribs) {
      return;
    }
    if (attribs.id === 'email') {
      // this is used in ChangeEmail's subtitle
      // eslint-disable-next-line consistent-return
      return <Email>{newEmail}</Email>;
    }
  };

  const { direction } = useLanguageDirection();

  return (
    <Container id="page-wrapper">
      {showHeader &&
        <StyledHeader>
          <StyledLogo alt="OneASICS™ Logo" src={AsicsSpiralLogoBlue} />
        </StyledHeader>
      }

      <main dir={direction}>
        <Stack id="page-wrapper-title-container" spacing={24}>
          {titleText && <TitleText>{titleText}</TitleText>}
          {subtitleText && <StyledSubtitle>{parse(subtitleText, { replace: copyReplacement })}</StyledSubtitle>}
        </Stack>

        <FlexSection id="flex-section" showHeader={showHeader}>{children}</FlexSection>
      </main>
    </Container>
  );
};

PageWrapper.propTypes = {
  /**
   * The body of the page.
   */
  children: PropTypes.node,
  /**
   * The text below the title.
   */
  subtitleText: PropTypes.string,
  /**
   * The text below the logo.
   */
  titleText: PropTypes.string,
};

export default PageWrapper;
